import { Formik, useFormikContext } from "formik";
import { Accordion, Col, Form, InputGroup, Row } from "react-bootstrap";
import Required from "../../Required";
import ReactTooltip from "react-tooltip";
import Select from "react-select";
import Fontstyling from "../../common/comman";

const RfpAdditionalQuestions = ({ additionalQuesTableData, formik, formName }) => {

  const {
    handleSubmit,
    handleChange,
    handleBlur,
    setFieldValue,
    values,
    touched,
    isValid,
    errors,
  } = formik || {};
  return (
    <Form id={formName} onSubmit={handleSubmit}>
      <Accordion defaultActiveKey={["0"]} alwaysOpen className="p-0 gap-3">
        <Accordion.Item as={"div"} className="border-0" eventKey="0">
          <Accordion.Button
            style={{...Fontstyling.cancelbutton,background:'#000921',color:"#FFF"}}
            className="p-0 pe-4 py-2 ps-2"
          >
            <div>
            <div style={Fontstyling.heading}>Additional Questions</div>
            {/* <div
                style={{
                  ...Fontstyling.primaryparagraph,
                  textTransform: "none",
                }}
              >
               Instructions:
              </div> */}
              </div>
          </Accordion.Button>
          <Accordion.Body className="p-0 py-3">
      <Row className="">
        {additionalQuesTableData?.map((que, qInd) => {
          return (
            <Col key={qInd} className="col-12 col-lg-6 px-3 py-2">
              <Form.Group className="row gap-2">
                <Form.Label
                  className="text-start col"
                  style={{
                    ...Fontstyling.label,
                  }}
                >
                  {que.questionsNumber}.{que.questionLabel} {que.fields[0].isPercentage && "(%)"}
                  {que.fields[0].required && <Required />}
                  {que.helpertext && <>
                    <img
                      data-tip={que.helpertext}
                      src={require("../../../assets/icon/Question_mark_back.png")}
                      style={{ height: 15, marginLeft: 3 }}
                    />
                    <ReactTooltip
                      className="border-2 border-info p-3 w-25 text-wrap"
                      border
                      backgroundColor="white"
                      textColor="black"
                    />
                  </>}
                </Form.Label>
                {
                  que.fields.map((field, fInd) => {
                    if (field.type === "text" || field.type === "textarea") {
                      return (
                        <Col className="col-12" key={fInd}>
                          <Form.Group className="text-start">
                            <InputGroup>
                              {field?.isAmount ? (
                                <InputGroup.Text className="py-0 fw-bold">
                                  $
                                </InputGroup.Text>
                              ) :
                                field?.isPercentage ? (
                                  <InputGroup.Text className="py-0 fw-bold">
                                    %
                                  </InputGroup.Text>
                                ) :
                                  field?.isNumber ? (
                                    <InputGroup.Text className="py-0 fw-bold">
                                      #
                                    </InputGroup.Text>
                                  ) : null}
                              <Form.Control
                                as={field?.type === 'textarea' ? 'textarea' : undefined}
                                name={field.name}
                                type={field.type}
                                className="py-1 rounded-0"
                                style={Fontstyling.label}
                                value={values[field.name]}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                disabled={field.disabled}
                                isInvalid={
                                  touched[field.name] && errors[field.name]
                                }
                                placeholder={""}
                              />
                              <Form.Control.Feedback type="invalid">
                                {errors[field.name]}
                              </Form.Control.Feedback>
                            </InputGroup>
                          </Form.Group>
                        </Col>
                      );
                    } else if (field.type === "dropdown") {
                      return (
                        <Col className="col-5" key={fInd}>
                          <Form.Group className="text-start">
                            <Form.Select
                              className="py-1 rounded-0"
                              style={Fontstyling.label}
                              name={field.name}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              isInvalid={
                                errors[field.name] && touched[field.name]
                              }
                              value={values[field.name]}
                              disabled={field?.disabled}
                            >
                              <option value={""}>Select</option>
                              {field.options?.map((opt, optInd) => (
                                <option key={optInd} value={opt.value}>
                                  {opt.lable}
                                </option>
                              ))}
                            </Form.Select>
                            <Form.Control.Feedback type="invalid">
                              {errors[field?.name]}
                            </Form.Control.Feedback>
                          </Form.Group>
                        </Col>
                      );
                    } else if (field?.type === "multiSelectDropdown") {
                      return (
                        <Col className="col-5" key={fInd}>
                          <Form.Group className="text-start">
                            <Select
                              isDisabled={field?.disabled}
                              name={field?.name}
                              isMulti
                              value={
                                values[field?.name]
                                  ? values[field?.name]
                                    ?.split(",")
                                    .map((item) => ({
                                      value: item,
                                      label: item,
                                    }))
                                  : values[field?.name]
                              }
                              className="py-0 rounded-0"
                              options={field?.options}
                              onChange={(selectedOption) => {
                                let option = selectedOption
                                  .map((item) => item.value)
                                  .join(",");
                                setFieldValue(field?.name, option);
                              }}
                              styles={{
                                control: (base, { isDisabled }) => ({
                                  ...Fontstyling.primaryparagraph,
                                  display: "flex",
                                  alignItems: "center",
                                  border:
                                    errors[field?.name] && touched[field?.name]
                                      ? "1px solid red"
                                      : "1px solid #ced4da",
                                  width: "auto",
                                  // maxHeight: "30px",
                                  height: "auto",
                                  textAlign: "left",
                                  backgroundColor: isDisabled ? "#e9ecef" : "",
                                }),
                                option: (
                                  styles,
                                  { data, isDisabled, isFocused, isSelected }
                                ) => {
                                  return {
                                    ...styles,
                                    ...Fontstyling.primaryparagraph,
                                    textAlign: "left",
                                  };
                                },
                                menu: (styles) => {
                                  return {
                                    ...styles,
                                    zIndex: "5",
                                  };
                                },
                              }}
                            />
                            {errors[field?.name] && touched[field?.name] && (
                              <div
                                className="fw-bold"
                                style={Fontstyling.errorlabel}
                              >
                                {errors[field?.name]}
                              </div>
                            )}
                          </Form.Group>
                        </Col>
                      );
                    } else if (field?.type === "dropdownTextArea") {
                      return (
                        <Row
                          className={`justify-content-end mt-1 ${values[field?.name.slice(0, -7)] === '-1'
                            ? "d-flex"
                            : "d-none"
                            }`}
                        >
                          <Col className="">
                            <Form.Group className="text-start">
                              <Form.Control
                                as="textarea"
                                rows={2}
                                name={field?.name}
                                className="py-1 rounded-0"
                                style={Fontstyling.label}
                                value={values[field?.name]}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                disabled={field?.disabled}
                                isInvalid={
                                  touched[field?.name] && errors[field?.name]
                                }
                                placeholder={field?.placeholder}
                              />
                              <Form.Control.Feedback type="invalid">
                                {errors[field?.name]}
                              </Form.Control.Feedback>
                            </Form.Group>
                          </Col>
                        </Row>
                      );
                    }
                  })
                }
              </Form.Group>
            </Col>
          )
        })}
      </Row>
      </Accordion.Body>
      </Accordion.Item>
      </Accordion>
    </Form>
  )
}

export default RfpAdditionalQuestions;